import axios from 'axios';
import { apiService } from './api';
import {
  DashboardMeta,
  MetaProcessRequest,
  MetaUploadRequest,
  MetaUploadResponse,
} from '@/types/metaProcessing';

export const fetchCurrentMeta = (userEmail: string, groupId: string): Promise<DashboardMeta> =>
  apiService.get<DashboardMeta>('/v1/meta-processing', {
    params: { user_email: userEmail, group_id: groupId },
  });

export const processMeta = (request: MetaProcessRequest): Promise<DashboardMeta> =>
  apiService.post<DashboardMeta>('/v1/meta-processing/process', request);

export const uploadMeta = (request: MetaUploadRequest): Promise<MetaUploadResponse> =>
  apiService.post<MetaUploadResponse>('/v1/meta-processing/upload', request);

/**
 * Parses editor text into the meta object the upload endpoint accepts, or null when it isn't
 * a JSON object (the user can edit the processed meta freely, so it may be invalid mid-edit).
 */
export const parseMeta = (text: string): DashboardMeta | null => {
  try {
    const parsed: unknown = JSON.parse(text);
    return typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)
      ? (parsed as DashboardMeta)
      : null;
  } catch {
    return null;
  }
};

export const getMetaProcessingErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.message ?? error.message;
  }
  return 'Something went wrong with meta processing. Please try again.';
};
